import {
    AssetClientTrickModeControlFlags,
    ClientBlackoutControlFlags,
    ClientNpvrControlFlags,
    ClientRestartControlFlags,
    ClientTimeshiftControlFlags,
    OOHControlFlags,
    RBProgramEditorialTechnical,
    RBRating,
} from 'store/railsBuilder/reducer.types';
import { RequestStatus } from 'store/utils';

export enum RecordingStatus {
    RECORDED = 'RECORDED',
    RECORDING = 'RECORDING',
    FAILED = 'FAILED',
    SCHEDULED = 'SCHEDULED',
}

export type RecordingError = {
    code: number;
    message: string;
};

export type RecordingPlaybackType = {
    drmId?: string;
    technicalId?: string;
    uri?: string;
    isStorageAllowed?: boolean;
    dynamicRange: any[];
};
export type PlaybackPlatforms = {
    IOS?: RecordingPlaybackType;
    Android?: RecordingPlaybackType;
    Browser?: RecordingPlaybackType;
};

export type RecordingItem = {
    id: string;
    status: RecordingStatus;
    eventId: string;
    channelId: string;
    contentId: string;
    captureEnd: string;
    captureDuration?: number;
    metadata: {
        [key: string]: RecordingMetadata;
    };
    contentType: string;
    seriesId?: string;
    seriesRecordingId?: string;
    isProtected: boolean;
    playback?: PlaybackPlatforms;
};

export type CachedRecordingItem = {
    id: string;
    seriesId?: string;
    seriesRecordingId?: string;
    status: RecordingStatus;
    eventId: string;
    isProtected: boolean;
    captureEnd: string;
    captureDuration?: number;
};
// const fields = [
//     'metadata.hu_HU.title',
//     'metadata.hu_HU.episode',
//     'metadata.hu_HU.SeasonNumber',
//     'metadata.hu_HU.episodeNumber',
//     'metadata.hu_HU.Description',
//     'metadata.hu_HU.promoImages',
//     'metadata.hu_HU.period',
//     'metadata.none.clientMobileNpvrControl',
//     'metadata.none.clientRecordingTrickModeControl',
//     'metadata.hu_HU.isnPvr',
//     'metadata.hu_HU.Ratings',
//     'metadata.hu_HU.contentRef',
//     'metadata.hu_HU.Subtitles',
//     'metadata.hu_HU.Audio',
//     'metadata.hu_HU.Genre',

//     'metadata.hu_HU.year',
// ];

export type RecordingMetadata = {
    id: string;
    title?: string;
    Title?: string;
    SeriesTitle?: string;
    episode?: string;
    Genre?: string[];
    Audio?: string[];
    Subtitles?: string[];
    Description?: string;
    Ratings?: RBRating[];
    serviceRef?: string;
    editorial?: {
        id: string;
        seriesRef?: string;
        technicals: RBProgramEditorialTechnical[];
    };
    period?: {
        duration: number;
        start: number | undefined;
        end: number | undefined;
    };
    episodeNumber?: string | number;
    SeasonNumber?: string | number;
    isnPvr?: boolean;
} & ClientBlackoutControlFlags &
    AssetClientTrickModeControlFlags &
    ClientTimeshiftControlFlags &
    ClientRestartControlFlags &
    ClientNpvrControlFlags &
    OOHControlFlags;

export type SeriesRecordingItem = {
    totalRecordings: number;
    recordingSet: RecordingItem[];
};

export enum SeriesStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
}

export enum NPVRAction {
    SCHEDULE = 'scheduleRequest',
    SCHEDULE_SERIES = 'scheduleSeriesRequest',
    PROTECT = 'protectRequest',
    UNPROTECT = 'unprotectRequest',
    DELETE = 'deleteRequest',
    DELETE_SERIES = 'deleteSeriesRequest',
    CANCEL = 'cancelRequest',
    CANCEL_SERIES = 'cancelSeriesRequest',
}

export type RecordingsState = {
    deleteRequest: {
        status: RequestStatus;
        errors: RecordingError | null;
    };
    deleteSeriesRequest: {
        status: RequestStatus;
        errors: RecordingError | null;
    };
    nPVRActions: NPVRAction[];

    cache: {
        timestamp: number | undefined;
        recordings: CachedRecordingsResponse['recordingSet'];
        series: SeriesRecordingResponse['series'];
    };

    deleteActionPinValidationTime: Record<string, number>;
};

export type RecordingResponse = {
    recordingSet: RecordingItem[];
    totalRecords: number;
};

export type CachedRecordingsResponse = {
    recordingSet: CachedRecordingItem[];
    totalRecords: number;
};

export type SeriesRecordingResponse = {
    seasons: string[];
    series: { id: string; recordingId: string; status: SeriesStatus }[];
    totalRecords: number;
};

export type QuotaUsage = {
    quotaTotal: string;
    currentUsage: string;
    remainder: string;
    usageSummary: {
        quotaRecorded: string;
        quotaScheduled: string;
        protectedRecordings: string;
        unProtectedRecordings: string;
    };
};
